<template>
	<div class="full-width">
		<v-tabs
			dark
			v-model="activeTab"
			slider-color="yellow"
			:color="themeInputColor"
		>
			<v-tab
				v-for="(tab, i) in isJeet11RBM ? rbmTabs : tabs"
				:key="i"
				:href="'#tab-' + i"
				:ripple="false"
				class="px-3"
			>
				{{ tab.name }}
			</v-tab>
		</v-tabs>

		<v-tabs-items v-if="!isJeet11RBM" v-model="activeTab">
			<v-tab-item value="tab-0">
				<v-container fluid fill-height class="pa-3">
					<v-layout row wrap class="full-width auto-height">
						<v-flex xs12>
							<v-card class="pa-5">
								<review-registrations
									:title="tabs[0].name"
									:themeInputColor="themeInputColor"
								></review-registrations>
							</v-card>
						</v-flex>
					</v-layout>
				</v-container>
			</v-tab-item>
			<v-tab-item value="tab-1">
				<v-container fluid fill-height class="pa-3">
					<v-layout row wrap class="full-width auto-height">
						<v-flex xs12>
							<v-card class="pa-5">
								<grab-retailer
									:title="tabs[1].name"
									:themeInputColor="themeInputColor"
								></grab-retailer>
							</v-card>
						</v-flex>
					</v-layout>
				</v-container>
			</v-tab-item>
			<v-tab-item value="tab-2">
				<v-container fluid fill-height class="pa-3">
					<v-flex xs12>
						<v-card>
							<retailer-dstr-list
								:title="tabs[2].name"
								:themeInputColor="themeInputColor"
							></retailer-dstr-list>
						</v-card>
					</v-flex>
				</v-container>
			</v-tab-item>
			<v-tab-item value="tab-3">
				<v-container fluid fill-height class="pa-3">
					<v-flex xs12>
						<v-card>
							<update-role
								:title="tabs[3].name"
								:themeInputColor="themeInputColor"
							/>
						</v-card>
					</v-flex>
				</v-container>
			</v-tab-item>
			<v-tab-item value="tab-4">
				<v-container fluid fill-height class="pa-3">
					<v-flex xs12>
						<v-card>
							<update-mapping
								:title="tabs[4].name"
								:themeInputColor="themeInputColor"
							/>
						</v-card>
					</v-flex>
				</v-container>
			</v-tab-item>
			<v-tab-item value="tab-5">
				<v-container fluid fill-height class="pa-3">
					<v-flex xs12>
						<v-card>
							<upload-user-stories
								:title="tabs[5].name"
								:themeInputColor="themeInputColor"
							/>
						</v-card>
					</v-flex>
				</v-container>
			</v-tab-item>
			<v-tab-item value="tab-6">
				<v-container fluid fill-height class="pa-3">
					<v-flex xs12>
						<v-card>
							<send-notification
								:title="tabs[6].name"
								:themeInputColor="themeInputColor"
							/>
						</v-card>
					</v-flex>
				</v-container>
			</v-tab-item>
			<v-tab-item value="tab-7">
				<v-container fluid fill-height class="pa-3">
					<v-flex xs12>
						<v-card>
							<map-tsm
								:title="tabs[7].name"
								:themeInputColor="themeInputColor"
							/>
						</v-card>
					</v-flex>
				</v-container>
			</v-tab-item>
			<v-tab-item value="tab-8">
				<v-container fluid fill-height class="pa-3">
					<v-flex xs12>
						<v-card>
							<active-inactive-user
								:title="tabs[8].name"
								:themeInputColor="themeInputColor"
							/>
						</v-card>
					</v-flex>
				</v-container>
			</v-tab-item>
			<v-tab-item value="tab-9">
				<v-container fluid fill-height class="pa-2">
					<v-flex xs12>
						<v-card>
							<dstr-sign-verify
								:title="tabs[9].name"
								:themeInputColor="themeInputColor"
							/>
						</v-card>
					</v-flex>
				</v-container>
			</v-tab-item>
			<v-tab-item value="tab-10">
				<v-container fluid fill-height class="pa-2">
					<v-flex xs12>
						<v-card>
							<dstr-invoice-verify
								:title="tabs[10].name"
								:themeInputColor="themeInputColor"
							/>
						</v-card>
					</v-flex>
				</v-container>
			</v-tab-item>
			<v-tab-item value="tab-11">
				<v-container fluid fill-height class="pa-3">
					<v-flex xs12>
						<v-card>
							<add-update-tsm-target
								:title="tabs[11].name"
								:themeInputColor="themeInputColor"
								:appType="appType"
							/>
						</v-card>
					</v-flex>
				</v-container>
			</v-tab-item>
			<v-tab-item value="tab-12">
				<v-container fluid fill-height class="pa-3">
					<v-flex xs12>
						<v-card>
							<add-update-dstr-target
								:title="tabs[12].name"
								:themeInputColor="themeInputColor"
								:appType="appType"
							/>
						</v-card>
					</v-flex>
				</v-container>
			</v-tab-item>
			<v-tab-item value="tab-13">
				<v-container fluid fill-height class="pa-3">
					<v-flex xs12>
						<v-card>
							<primary-day-automation
								:title="tabs[13].name"
								:themeInputColor="themeInputColor"
								:appType="appType"
							/>
						</v-card>
					</v-flex>
				</v-container>
			</v-tab-item>
			<v-tab-item value="tab-14">
				<v-container fluid fill-height class="pa-3">
					<v-flex xs12>
						<v-card>
							<add-update-leaderboard
								:title="tabs[14].name"
								:themeInputColor="themeInputColor"
								:appType="appType"
							/>
						</v-card>
					</v-flex>
				</v-container>
			</v-tab-item>
		</v-tabs-items>

		<v-tabs-items v-if="isJeet11RBM" v-model="activeTab">
			<v-tab-item value="tab-0">
				<v-container fluid fill-height class="pa-3">
					<v-layout row wrap class="full-width auto-height">
						<v-flex xs12>
							<v-card class="pa-5">
								<review-registrations
									:title="rbmTabs[0].name"
									:themeInputColor="themeInputColor"
								></review-registrations>
							</v-card>
						</v-flex>
					</v-layout>
				</v-container>
			</v-tab-item>
			<v-tab-item value="tab-1">
				<v-container fluid fill-height class="pa-3">
					<v-layout row wrap class="full-width auto-height">
						<v-flex xs12>
							<v-card class="pa-5">
								<update-mapping
									:title="rbmTabs[1].name"
									:themeInputColor="themeInputColor"
								/>
							</v-card>
						</v-flex>
					</v-layout>
				</v-container>
			</v-tab-item>
			<v-tab-item value="tab-2">
				<v-container fluid fill-height class="pa-3">
					<v-flex xs12>
						<v-card>
							<active-inactive-user
								:title="rbmTabs[2].name"
								:themeInputColor="themeInputColor"
							/>
						</v-card>
					</v-flex>
				</v-container>
			</v-tab-item>
		</v-tabs-items>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import { themeInputColor } from "@/utils";
import Review from "./Review";
import GrabRetailer from "./Grab-retailer";
import RetailerDstrList from "./retailer-dstr-list";
import UpdateMapping from "./update-mapping";
import UpdateRole from "./update-role";
import UploadUserStories from "./UploadUserStories";
import SendNotification from "./send-notification";
import MapTSM from "./MapTSM";
import ActiveInactiveUser from "./active-inactive-user.vue";
import AddUpdateTSMTarget from "./addUpdateTSMTarget";
import AddUpdateDstrTarget from "./addUpdateDstrTarget";
import DstrSignVerify from "./dstr-sign-verify.vue";
import DstrInvoiceVerify from "./dstr-invoice-verify.vue";
import PrimaryDayAutomation from "./primary-day-automation.vue";
import AddUpdateLeaderboard from "./addUpdateLeaderboard.vue";

export default {
	name: "RetailAdminTools",
	props: ["appType"],
	data() {
		return {
			activeTab: "tab-0",
			themeInputColor,
			tabs: [
				{ name: "Review Registrations" },
				{ name: "Grab Retailer" },
				{ name: "All Retailers/Distributors" },
				{ name: "Update Retailer Data" },
				{ name: "Update Mapping" },
				{ name: "Upload User Story" },
				{ name: "Send Notification" },
				{ name: "Map TSM/RBM" },
				{ name: "Active/Inactive User" },
				{ name: "DSTR Signature Approval" },
				{ name: "GST Invoice Verification" },
				{ name: "Add/Update Date Range Targets" },
				{ name: "Add/Update Monthly Targets" },
				{ name: "Primary Day Automation" },
				{ name: "Add/Update Leaderboard" }
			],
			rbmTabs: [
				{ name: "Review Registrations" },
				{ name: "Update Mapping" },
				{ name: "Active/Inactive User" }
			]
		};
	},
	computed: {
		...mapGetters({
			isJeet11RBM: "auth/isJeet11RBM"
		})
	},
	components: {
		"review-registrations": Review,
		"grab-retailer": GrabRetailer,
		"retailer-dstr-list": RetailerDstrList,
		"update-mapping": UpdateMapping,
		"update-role": UpdateRole,
		"upload-user-stories": UploadUserStories,
		"send-notification": SendNotification,
		"map-tsm": MapTSM,
		"active-inactive-user": ActiveInactiveUser,
		"add-update-tsm-target": AddUpdateTSMTarget,
		"add-update-dstr-target": AddUpdateDstrTarget,
		"dstr-sign-verify": DstrSignVerify,
		"dstr-invoice-verify": DstrInvoiceVerify,
		"primary-day-automation": PrimaryDayAutomation,
		"add-update-leaderboard": AddUpdateLeaderboard
	}
};
</script>
